import { useEffect, useState } from 'react';
import {
  Warning,
  WarningTitleIcon,
  WarningPanel,
  WarningIcon,
} from 'src/components/warning';
import { Box, Stack, Text } from '@chakra-ui/react';
import { IoTicket } from 'react-icons/io5';
import { EventCoupon } from 'src/types/dto';

import { useDiscountRules } from '../../hooks';
import { toMoney } from 'src/legacy/Utils/Conversor';

export const DiscountWarning: React.FC<{
  data: EventCoupon;
  isCouponApplied: boolean;
}> = ({ data, isCouponApplied }) => {
  const [isOpen, setOpen] = useState(!isCouponApplied);
  const discountRules = useDiscountRules();
  const hasRules = discountRules.length > 0;

  let title = `Cupom "${data.name}" disponível`;

  if (isCouponApplied) {
    title = `Cupom "${data.name}" aplicado`;
  }

  const discountText = !!data.percentageDiscount
    ? data.percentageDiscount > 0
      ? `${Math.round(data.percentageDiscount * 100)}%`
      : ''
    : (data.priceDiscount ?? 0) > 0
      ? `${toMoney(Math.round(data.priceDiscount ?? 0))}`
      : '';

  useEffect(() => {
    setOpen(!isCouponApplied);
  }, [isCouponApplied]);

  return (
    <Warning
      {...{ isOpen }}
      onChange={setOpen}
      colorScheme="green"
      borderRadius="md"
      closeOnClickOutside={false}
      px={4}
      py={3}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        position="relative">
        <Box display="flex" justifyContent="center" flexGrow="1" gap="2">
          <WarningTitleIcon as={IoTicket} />
          <Text
            mr="4"
            as="h3"
            fontSize="sm"
            color="green.600"
          >
            {`${title}${discountText ? `. ${discountText} de desconto` : ''}`}
          </Text>
        </Box>

        {hasRules && <WarningIcon mr="0" />}
      </Box>
      {hasRules && (
        <WarningPanel>
          <Stack align="center" fontSize="sm" textAlign="center" pt={3}>
            {discountRules.map(rule => (
              <Text key={rule.id}>{rule.message}</Text>
            ))}
          </Stack>
        </WarningPanel>
      )}
    </Warning>
  );
};
